<template>
  <button class="room-attendance-btn" :class="{isOpenControlMenu: isOpenControlMenu && isMobile}" @click="regAttend">
    <img src="@/assets/images/camstudy/ico_check_white.svg" class="ico-check-attendance" />
    {{ $t('camstudy.attendance.checkIn') }}
  </button>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {Room} from "@/core/api/room.api";
import {Device} from "@/utils"

export default {
  name: 'CamStudyAttendance',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('user', ['me']),
    ...mapGetters('common', [
        'isOpenControlMenu'
    ]),
    isMobile(){
      return Device.isMobile();
    }
  },
  methods:{
    ...mapActions('camstudy', [
      'getTodayCamStudyData',
      'createTodayCamStudyUserData',
    ]),
    regAttend() {
      this.getTodayCamStudyData()
          .then(data => {
            if(data.today) {
              this.$camsAlert({
                text: this.$t('camstudy.attendance.alreadyCheckedIn'),
                onlyOk: true
              })
            } else {
              this.$camsAlert({
                title: this.$t('camstudy.attendance.checkInConfirm'),
                text: this.$t('camstudy.attendance.checkInDescription'),
                ok: () => {
                  this.createTodayCamStudyUserData()
                }
              })
            }
          })
    }
  }
}

</script>

<style scoped lang="scss">
  .room-attendance-btn {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    height: 40px;
    transition: 0.2s;
    z-index: 999;

    padding: 0 18px;
    border-radius: 30px;
    background: #016FF2;
    box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);

    color: #FFF;
    font-size: 16px;
    font-weight: 700;

    display: flex;
    gap: 6px;
    align-items: center;
    &.isOpenControlMenu{
      bottom: 88px;
    }
    .ico-check-attendance{
      width: 24px;
      height: 24px;
      padding: 4px;
    }
  }
</style>